<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <div>
      TDS Breakup
      <div class="container">
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total Taxable Income:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 10,00,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Taxable Income round off to nearest 10 rupees:</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
      </div>
      
      <hr>

      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Total Tax to be paid</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Actual Tax</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Tax Rebate</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Tax</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Surcharge</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Edu. Cess</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
      </div>
      
      <hr>

      <div class="section-table">
      
        <h2 class="title-income my-3">Total Tax Paid Till Date</h2>
        
        <!-- Table -->
        <div class="datatable-outer-container">
            <div class="datatable-main">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th></th>
                      <th>Tax</th>
                      <th>Surcharge</th>
                      <th>Edu. Cess</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tr class="record-row">
                    <td class="row-item">
                      Deduction Through Payroll
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      Direct TDS
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      Previous Employment
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                    <td class="row-item">
                      ₹ 1,20,000
                    </td>
                  </tr>
                  <tr class="record-row">
                    <td class="row-item">
                      <strong>Total</strong>
                    </td>
                    <td class="row-item">
                      <strong>₹ 1,20,000</strong>
                    </td>
                    <td class="row-item">
                      <strong>₹ 1,20,000</strong>
                    </td>
                    <td class="row-item">
                      <strong>₹ 1,20,000</strong>
                    </td>
                    <td class="row-item">
                      <strong>₹ 1,20,000</strong>
                    </td>
                  </tr>
                </table>
              </div>
        </div>
        <!-- End -->
        
      </div>

      <div class="container">
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Balance Tax Payable/Refund</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 10,00,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Balance Payable (in 1 installments) - Income Tax</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
      </div>
      
      <hr>

      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="title-income">Closed Month Tax Deduction</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">Regular Tax</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-normal-left">One Time Tax</p>
          </div>
          <div class="col-4">
            <p class="title-income-normal-right">₹ 1,20,000</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8">
            <p class="title-income-left">Total</p>
          </div>
          <div class="col-4">
            <p class="title-income-right">₹ 1,20,000</p>
          </div>
        </div>
      </div>
    
      <!-- <pop-up-message
        v-if="showSuccessMsg"
        :message="`Components successfully added`"
        btnText="Back To Assign Fixed Non CTC Components "
        @back="close"
      ></pop-up-message> -->

      <footer>
        <popup-bottom-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Back" type="secondary" @click="goBack" />
            </btn-grp>
          </template>
        </popup-bottom-container>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  name: "tdsBreakupNewRegimePopup",
  props: {
  },
  data() {
    return {
      errmsg: "",
      toast: false,
      showSuccessMsg: false,
    };
  },
  computed: {},

  mounted() {
    this.showSuccessMsg = false;
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    this.showSuccessMsg = false;
  },

  methods: {
    // Add here code for cancel button to hide popup By Bhushan
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>

// .business {
//   width: 100%;
//   height: 100%;
// }

// .business .top-bar {
//   height: auto;
//   padding: 20px;
//   background-color: #34c0be;
//   display: flex;
// }

.title-income {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-normal-left {
  font-size: 1.0rem;
  color: #444444;
}

.title-income-normal-right {
  font-size: 1.0rem;
  color: #444444;
  text-align: right;
}

.title-income-left {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
}

.title-income-right {
  font-size: 1.1rem;
  font-weight: 600;
  color: #444444;
  text-align: right;
}

.section-table {
  padding: 24px 0px;
}

.datatable-outer-container {
  width: 100%;
}
        
.datatable-outer-container table.datatable {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
            font-family: Montserrat;
            margin-bottom: 4px;
}
        
        .datatable-outer-container table.datatable .header-row {
            background-color: white;
            height: 54px;
        }
        
        .datatable-outer-container table.datatable .header-row th {
            background-color: #f0f1f5;
            border-bottom: 1px solid #34c0be;
            padding: 6px 8px;
        }
        
        .datatable-outer-container table.datatable .header-row th .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .inactiveCols {
            opacity: 0.03;
            background-color: #a2a1a1;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader {
            background-color: #ffffff;
            -webkit-box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
            box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th {
            padding: 0 8px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span {
            border-right: 1px solid #ececec;
            padding: 0px 18px 0px 15px;
            display: inline-block;
            vertical-align: middle;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th span:first-child {
            padding: 10px 10px 7px 10px;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type {
            text-align: right;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
        }
        
        .datatable-outer-container table.datatable .Editdeleteheader th:last-of-type span i {
            position: absolute;
            right: 10px;
            top: 2px;
        }
        
        .datatable-outer-container table.datatable .record-row {
            height: 54px;
            border-bottom: 1px solid #d8d8d8;
        }
        
        .datatable-outer-container table.datatable .record-row:nth-child(odd) {
            background-color: #f5f6fa;
        }
        
        .datatable-outer-container table.datatable .record-row.selectedRecord {
            background-color: #E9F9F8;
            opacity: 0.9;
        }
        
        .datatable-outer-container table.datatable .record-row td {
            padding: 6px 8px;
            color: #646464;
            font-weight: 500;
        }
        
        .datatable-outer-container table.datatable .record-row td .tl-checkbox {
            text-align: center;
        }
        
        .datatable-outer-container table.datatable .record-row .actions {
            width: 10%;
            padding: 10px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item {
            padding: 6px 8px;
        }
        
        .datatable-outer-container table.datatable .record-row .row-item p {
            width: 100%;
            margin-bottom: 0px;
        }
        
        .datatable-outer-container table.datatable .record-row .action-img {
            display: inline-block;
            cursor: pointer;
            opacity: 0;
        }
        
        .datatable-outer-container table.datatable .record-row:hover .action-img {
            opacity: 1;
        }

</style>
